var map = {
	"./alpgw_web.png": 5117,
	"./moonshot.png": 4526,
	"./nuhs_balloon.png": 2463,
	"./nuhs_dalgona.png": 8680,
	"./nuhs_wordle.png": 1705,
	"./queenswayAF.png": 2187,
	"./webbricks_web.png": 9045
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8886;